"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M10.87 0a.874.874 0 0 0-.754.44L6.365 7H.85a.85.85 0 0 0-.679.356c-.109.165-.17.359-.17.545 0 .079.011.156.034.23l2.512 10.782C2.896 20.165 3.972 21 5.214 21h13.599l-.02-.01c1.242 0 2.319-.845 2.678-2.108L23.964 8.14A.91.91 0 0 0 24 7.885v-.002a.932.932 0 0 0-.163-.527A.824.824 0 0 0 23.16 7h-5.045L14.365.44a.874.874 0 0 0-.754-.44.847.847 0 0 0-.436.12.88.88 0 0 0-.33 1.19L16.096 7H8.383l3.252-5.69a.88.88 0 0 0-.33-1.19.847.847 0 0 0-.436-.12Z",
    clipRule: "evenodd"
  })]
});